import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './App.scss';
import Navbar from './components/Navbar';
import Breadcrumb from './components/Breadcrumb';
import Home from './pages/Home';
import SignIn from './pages/SignIn';
import SignOut from './pages/SignOut';
import Provider from './pages/Provider';
import AddProvider from './pages/Provider/AddProvider';
import RoutingGuideRoutes from './pages/RoutingGuide/RoutingGuideRoutes';
import ClosingRules from './pages/Rules/ClosingRules';
import AddClosingRule from './pages/Rules/AddClosingRule';
import EditClosingRule from './pages/Rules/EditClosingRule';
import CarriageRules from './pages/Rules/CarriageRules';
import AddCarriageRule from './pages/Rules/AddCarriageRule';
import EditCarriageRule from './pages/Rules/EditCarriageRule';
import Rules from './pages/Rules'; // Import the Rules component
import Reports from './pages/Reports';
import Users from './pages/Users';
import UserEdit from './pages/Users/UserEdit';
import UserSettings from './pages/Users/UserSettings';
import Unauthorized from './pages/Unauthorized';
import PrivateRoute from './components/PrivateRoute';
import { AuthProvider } from './context/AuthContext';


function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Helmet>
            <title>{process.env.REACT_APP_SITE_NAME}</title>
          </Helmet>
          <Navbar />
          <div className="pageContainer">
            <Breadcrumb />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/signin" element={<SignIn />} />
              <Route path="/signout" element={<SignOut />} />
              <Route path="/unauthorized" element={<Unauthorized />} />

              {/* Private routes */}
              <Route element={<PrivateRoute requiredPermissions={['Manage Providers']}/>}>
                <Route path="/provider" element={<Provider />} />
                <Route path="/provider/add" element={<AddProvider />} />
              </Route>
              <Route element={<PrivateRoute requiredPermissions={['Manage Routing Guides']}/>}>
                <Route path="/routing-guide/*" element={<RoutingGuideRoutes />} />
              </Route>
              <Route element={<PrivateRoute requiredPermissions={['Manage Closing Rules']}/>}>
                <Route path="/rules/closing" element={<ClosingRules />} />
                <Route path="/rules/closing/add" element={<AddClosingRule />} />
                <Route path="/rules/closing/edit/:id" element={<EditClosingRule />} />
              </Route>
              <Route element={<PrivateRoute requiredPermissions={['Manage Carriage Rules']}/>}>
                <Route path="/rules/carriage" element={<CarriageRules />} />
                <Route path="/rules/carriage/add" element={<AddCarriageRule />} />
                <Route path="/rules/carriage/edit/:id" element={<EditCarriageRule />} />
              </Route>
              <Route path="/rules/*" element={<Rules />} />
              <Route path="/reports" element={<Reports />} />
              <Route element={<PrivateRoute requiredPermissions={['Manage Users']}/>}>
                <Route path="/users" element={<Users />} />
                <Route path="/users/edit/:userid" element={<UserEdit />} />
              </Route>
              <Route element={<PrivateRoute requiredPermissions={[]}/>}>
                <Route path="/user-settings" element={<UserSettings />} />
              </Route>
            </Routes>
          </div>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
